import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2, Rocket } from 'lucide-react';
export function WhyUnique() {
  return <section className="py-14 md:py-16 bg-[#111827]" data-id="element-196">
      <div className="max-w-[980px] mx-auto px-4" data-id="element-197">
        <motion.div initial={{
        opacity: 0,
        y: 16
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-12" data-id="element-198">
          <h2 className="text-[24px] md:text-[32px] font-black text-white mb-4 uppercase" data-id="element-199">
            Por qué el KIT SUBLIMACIÓN & DTF VIRAL es único
          </h2>
          <h3 className="text-xl text-[#f5a623] font-bold" data-id="element-200">
            ¿Qué vas a recibir?
          </h3>
        </motion.div>

        <div className="glass-card p-6 md:p-10 mb-10 max-w-3xl mx-auto" data-id="element-201">
          <ul className="space-y-5 mb-8" data-id="element-202">
            {['Acceso al KIT SUBLIMACIÓN & DTF VIRAL', 'Miles de archivos compatibles y editables para comenzar a vender', 'Diseños organizados y listos para producción real'].map((item, idx) => <motion.li key={idx} initial={{
            opacity: 0,
            x: -16
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: idx * 0.08
          }} className="flex items-center space-x-3" data-id="element-203">
                <CheckCircle2 className="w-6 h-6 text-[#22c55e] flex-shrink-0" data-id="element-204" />
                <span className="text-[17px] md:text-lg text-white font-medium" data-id="element-205">
                  {item}
                </span>
              </motion.li>)}
          </ul>

          <div className="bg-[#0a0e1a] p-5 rounded-xl border border-white/10 mb-8" data-id="element-206">
            <h4 className="text-lg font-bold text-white mb-1.5" data-id="element-207">
              Te ahorra horas todos los días
            </h4>
            <p className="text-[17px] text-gray-400" data-id="element-208">
              Olvidate de buscar imágenes mal recortadas, de baja calidad o que
              no sirven para sublimar.
            </p>
          </div>

          <motion.div initial={{
          opacity: 0,
          y: 16
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="border-t border-white/10 pt-8" data-id="element-209">
            <div className="flex items-center space-x-3 mb-5" data-id="element-210">
              <Rocket className="w-7 h-7 text-[#f5a623]" data-id="element-211" />
              <h3 className="text-xl font-bold text-white" data-id="element-212">BONOS EXCLUSIVOS</h3>
            </div>
            <p className="text-[17px] text-gray-300 mb-5" data-id="element-213">
              Incluye diseños adicionales para expandir tu catálogo:
            </p>
            <div className="grid grid-cols-2 md:grid-cols-4 gap-3" data-id="element-214">
              {['Almohadones', 'Ojotas / Flip Flops', 'Bolsos', 'Stickers'].map((bono, idx) => <div key={idx} className="bg-[#1a1f35] p-3 rounded-lg text-center border border-[#f5a623]/30" data-id="element-215">
                    <span className="text-[#f5a623] font-bold text-sm" data-id="element-216">
                      ✔ {bono}
                    </span>
                  </div>)}
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}